import type { Testimonial } from "./types";

export const testimonials: Testimonial[] = [
  {
    id: "test-1",
    quote: "91EatGossip是我每天必刷的网站，爆料速度比任何平台都快，而且内容真实有料。上次那个明星出轨的新闻，我这里比全网热搜还早两个小时看到！",
    author: "吃瓜达人小王",
    role: "忠实读者 · 追更3年",
    rating: 4.9,
    avatar: "https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20young%20asian%20man%20with%20neutral%20expression%20soft%20warm%20studio%20lighting%20clean%20background%20editorial%20style&width=200&height=200&seq=avatar-01&orientation=squarish",
  },
  {
    id: "test-2",
    quote: "作为媒体人，我必须说这个网站的爆料质量非常高。很多独家消息后续都被证实了，信息来源可靠，不像有些网站只会编故事。",
    author: "资深娱记李老师",
    role: "娱乐媒体人 · 从业15年",
    rating: 4.8,
    avatar: "https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20middle%20aged%20asian%20woman%20journalist%20with%20glasses%20warm%20studio%20lighting%20clean%20background%20editorial%20style&width=200&height=200&seq=avatar-02&orientation=squarish",
  },
  {
    id: "test-3",
    quote: "视频清晰度真的没话说，很多别的网站模糊到看不清人脸，这里的偷拍视频画质堪比纪录片。而且更新频率感人，半夜都有新料！",
    author: "夜猫子追星族",
    role: "视频爱好者 · 每日访问",
    rating: 4.7,
    avatar: "https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20young%20asian%20woman%20with%20casual%20style%20soft%20warm%20studio%20lighting%20clean%20background%20editorial%20style&width=200&height=200&seq=avatar-03&orientation=squarish",
  },
  {
    id: "test-4",
    quote: "网站的分类做得很好，想找什么类型的瓜一搜就有。而且不会乱收费，很多视频都是免费观看，良心平台必须支持！",
    author: "理性吃瓜群众",
    role: "学生党 · 每周访问",
    rating: 4.8,
    avatar: "https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20young%20asian%20man%20student%20style%20warm%20studio%20lighting%20clean%20background%20editorial%20style&width=200&height=200&seq=avatar-04&orientation=squarish",
  },
];
